import type { IPermissionRepository } from '@src/domain/rbac/repository/permission_repository';
import type { Permission } from '@src/domain/rbac/entities/permission.entity';

/**
 * List All Permissions Use Case
 * Retrieves all permissions in the system
 */
export class ListAllPermissionsUseCase {
    constructor(private readonly permissionRepository: IPermissionRepository) { }

    async execute(): Promise<Permission[]> {
        return await this.permissionRepository.listAll();
    }
}
